var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"light":""}},[_c('v-toolbar',{attrs:{"color":"white"}},[_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.title)}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }